import { FileUploadZone, type UploadedFile } from './FileUploadZone';

interface TeamData {
  teamSize: number;
  seniorityLevel: string;
  avgYearsExperience: number;
}

interface TeamSectionProps {
  data: TeamData;
  onChange: (data: TeamData) => void;
  questionnaireId: string;
  uploads: UploadedFile[];
  onUploadsChange: (uploads: UploadedFile[]) => void;
}

export function TeamSection({
  data,
  onChange,
  questionnaireId,
  uploads,
  onUploadsChange,
}: TeamSectionProps) {
  const update = <K extends keyof TeamData>(field: K, value: TeamData[K]) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="space-y-5">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Sales Team Size</label>
        <input
          type="number"
          min={0}
          value={data.teamSize || ''}
          onChange={(e) => update('teamSize', parseInt(e.target.value) || 0)}
          placeholder="Number of sales team members"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Team Seniority Level</label>
        <select
          value={data.seniorityLevel}
          onChange={(e) => update('seniorityLevel', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        >
          <option value="">Select seniority level</option>
          <option value="junior">Mostly Junior (0-3 years)</option>
          <option value="mixed">Mixed (varied experience)</option>
          <option value="senior">Mostly Senior (5+ years)</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Average Years of Experience
        </label>
        <input
          type="number"
          min={0}
          step={0.5}
          value={data.avgYearsExperience || ''}
          onChange={(e) => update('avgYearsExperience', parseFloat(e.target.value) || 0)}
          placeholder="e.g., 3.5"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      <div className="pt-2">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Team Documents (org chart, etc.)
        </label>
        <FileUploadZone
          questionnaireId={questionnaireId}
          section="team"
          uploads={uploads}
          onUploadsChange={onUploadsChange}
        />
      </div>
    </div>
  );
}
